module.exports = __webpack_public_path__ + "pc/img/career-planner.239e67f5.png";